module.exports = __webpack_public_path__ + "static/zaplist-bc809945779e07d1c8216ab208bd5792.png";